<template>
  <div class="module-edit">
    <SelectServer ref="developSelectServer" v-on:selectServerComplete="developSelectServerComplete"></SelectServer>
    <SelectServer ref="testSelectServer" v-on:selectServerComplete="testSelectServerComplete"></SelectServer>
    <SelectServer ref="productSelectServer" v-on:selectServerComplete="productSelectServerComplete"></SelectServer>
    <SelectJenkinsJobs ref="SelectJenkinsJobs" v-on:selectComplete="selectJenkinsJobsComplete"></SelectJenkinsJobs>
    <Card shadow class="content workflow-module-edit-content">
      <div class="main">
        <Row class="title">
          <h4 :style="{float: 'left'}">模块基本信息</h4>
        </Row>
        <Alert show-icon>你正在添加「<b style="color: red">{{ tenantInfo.name }}</b>」项目的模块，可从右上角切换项目</Alert>
        <Alert v-if="moduleInfoError" type="warning" show-icon>获取模块详情数据失败</Alert>
        <Form :label-width="68" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo" v-else>
          <Row>
            <Col :md="24" :lg="12">
              <FormItem label="模块名" style="width: 100%" prop="name">
                <Input :maxlength="100" v-model="baseInfo.name"/>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12">
              <FormItem label="模块Code" style="width: 100%" prop="code">
                <Input :maxlength="100" v-model="baseInfo.code"/>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12">
              <FormItem label="开发人员" style="width: 100%" prop="developers">
                <Select v-model="baseInfo.developers" multiple placeholder="选择开发人员" filterable transfer>
                  <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="描述" style="width: 100%">
                <Input type="textarea" :maxlength="512" v-model="baseInfo.description" :rows="5" />
              </FormItem>
            </Col>
          </Row>
        </Form>
        <Row class="title">
          <h4 :style="{float: 'left'}">模块部署信息</h4>
        </Row>
        <Alert v-if="deploymentInfoError" type="warning" show-icon>获取模块部署信息数据失败</Alert>
        <div v-else>
          <Form>
            <FormItem label="选择环境" :label-width="70">
              <CheckboxGroup v-model="scenesSelected" style="padding-left: 20px">
                <Checkbox :label="item.value" v-for="item in scenesList" :key="item.value">
                  <span>{{ item.label }}</span>
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
          </Form>
          <Form inline :label-width="85" ref="developDeploymentInfo" :model="developDeploymentInfo" v-if="scenesSelected.indexOf('develop') > -1" class="develop-deployment-info-form">
            <Alert show-icon>
              <b>开发环境</b>
              <Icon type="ios-bulb-outline" slot="icon"></Icon>
              <Row style="padding-top: 20px">
                <Col span="24">
                  <FormItem label="部署服务器" style="width: 95%" prop="server">
                    <Button type="default" icon="ios-desktop-outline" @click="openSelectServerModal('developDeploymentInfo', 'developSelectServer')" style="margin-right: 5px;position: relative;z-index: 2;" size="small">
                      <span v-if="!developDeploymentInfo.server.length">选择</span>
                    </Button>
                    <Tag v-for="serverItem in developDeploymentInfo.server" :key="'develop_server_' + serverItem.id" color="primary">{{ serverItem.hostname }}</Tag>
                  </FormItem>
                </Col>
                <Col span="24">
                  <FormItem label="Jenkins Job" style="width: 95%" prop="jenkins_job">
                    <Button type="default" size="small" @click="openSelectJenkins('developDeploymentInfo')"  style="margin-right: 5px;position: relative;z-index: 2;">
                      <span v-if="!developDeploymentInfo.jenkins_job">选择</span>
                      <span v-else>修改</span>
                    </Button>
                    <Tag color="primary" v-if="developDeploymentInfo.jenkins_job">{{ developDeploymentInfo.jenkins_job }}</Tag>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12">
                  <FormItem label="部署地址" style="width: 95%" prop="address_in">
                    <Input :maxlength="200" v-model="developDeploymentInfo.address_in"/>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12">
                  <FormItem label="部署外网地址" style="width: 95%" prop="address_ex">
                    <Input :maxlength="200" v-model="developDeploymentInfo.address_ex"/>
                  </FormItem>
                </Col>
              </Row>
            </Alert>
          </Form>
          <Form inline :label-width="90" ref="testDeploymentInfo" :model="testDeploymentInfo" v-if="scenesSelected.indexOf('test') > -1" class="test-deployment-info-form">
            <Alert show-icon type="warning">
              <b>测试环境</b>
              <Icon type="ios-bulb-outline" slot="icon"></Icon>
              <Row style="padding-top: 20px">
                <Col span="24">
                  <FormItem label="部署服务器" style="width: 95%" prop="server">
                    <Button type="default" icon="ios-desktop-outline" @click="openSelectServerModal('testDeploymentInfo', 'testSelectServer')" style="margin-right: 5px;position: relative;z-index: 2" size="small">
                      <span v-if="!testDeploymentInfo.server.length">选择</span>
                    </Button>
                    <Tag v-for="serverItem in testDeploymentInfo.server" :key="'develop_server_' + serverItem.id" color="primary">{{ serverItem.hostname }}</Tag>
                  </FormItem>
                </Col>
                <Col span="24">
                  <FormItem label="Jenkins Job" style="width: 95%" prop="jenkins_job">
                    <Button type="default" size="small" @click="openSelectJenkins('testDeploymentInfo')"  style="margin-right: 5px;position: relative;z-index: 2">
                      <span v-if="!testDeploymentInfo.jenkins_job">选择</span>
                      <span v-else>修改</span>
                    </Button>
                    <Tag color="primary" v-if="testDeploymentInfo.jenkins_job">{{ testDeploymentInfo.jenkins_job }}</Tag>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12">
                  <FormItem label="部署地址" style="width: 95%" prop="address_in">
                    <Input :maxlength="200" v-model="testDeploymentInfo.address_in"/>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12">
                  <FormItem label="部署外网地址" style="width: 95%" prop="address_ex">
                    <Input :maxlength="200" v-model="testDeploymentInfo.address_ex"/>
                  </FormItem>
                </Col>
              </Row>
            </Alert>
          </Form>
          <Form inline :label-width="90" ref="productDeploymentInfo" :model="productDeploymentInfo" v-if="scenesSelected.indexOf('product') > -1" class="product-deployment-info-form">
            <Alert show-icon type="error">
              <b>生产环境</b>
              <Icon type="ios-bulb-outline" slot="icon"></Icon>
              <Row style="padding-top: 20px">
                <Col span="24">
                  <FormItem label="部署服务器" style="width: 95%" prop="server">
                    <Button type="default" icon="ios-desktop-outline" @click="openSelectServerModal('productDeploymentInfo', 'productSelectServer')" style="margin-right: 5px;position: relative;z-index: 2" size="small">
                      <span v-if="!productDeploymentInfo.server.length">选择</span>
                    </Button>
                    <Tag v-for="serverItem in productDeploymentInfo.server" :key="'develop_server_' + serverItem.id" color="primary">{{ serverItem.hostname }}</Tag>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12">
                  <FormItem label="Jenkins Job" style="width: 95%" prop="jenkins_job">
                    <Button type="default" size="small" @click="openSelectJenkins('productDeploymentInfo')"  style="margin-right: 5px;">
                      <span v-if="!productDeploymentInfo.jenkins_job">选择</span>
                      <span v-else>修改</span>
                    </Button>
                    <Tag color="primary" v-if="productDeploymentInfo.jenkins_job">{{ productDeploymentInfo.jenkins_job }}</Tag>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12">
                  <FormItem label="部署地址" style="width: 95%" prop="address_in">
                    <Input :maxlength="200" v-model="productDeploymentInfo.address_in"/>
                  </FormItem>
                </Col>
                <Col :md="24" :lg="12">
                  <FormItem label="部署外网地址" style="width: 95%" prop="address_ex">
                    <Input :maxlength="200" v-model="productDeploymentInfo.address_ex"/>
                  </FormItem>
                </Col>
              </Row>
            </Alert>
          </Form>
        </div>
        <div style="text-align: center; padding: 20px 0;">
          <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit" :disabled="deploymentInfoError || moduleInfoError">提交</Button>
          <Button @click="$router.go(-1)">取消</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import SelectServer from '@/view/ops-center/select-server'
import SelectJenkinsJobs from '@/view/tools/jenkins/components/select-jenkins-jobs'
import ApprovalProcess from '../components/approval-process'
import ApprovalSteps from '../components/approval-steps'
import { GetALLUsers, detailTenants } from '@/api/user'
import { changeModule, detailModule, getModuleDevelopments } from '@/api/workflow/project'
export default {
  name: 'edit',
  components: {
    SelectServer,
    SelectJenkinsJobs,
    ApprovalProcess,
    ApprovalSteps
  },
  data () {
    return {
      title: this.$route.params.id ? '编辑模块' : '添加模块',
      tenantInfo: {},
      baseInfo: {
        id: '',
        name: '',
        code: '',
        description: '',
        developers: []
      },
      baseInfoFormRules: {
        name: { required: true, message: '模块名不能为空', trigger: 'blur' }
      },
      userList: [],
      scenesList: [
        // { value: 'develop', label: '开发环境' },
        { value: 'test', label: '测试环境' },
        { value: 'product', label: '生产环境' }
      ],
      dbTypeList: [
        { value: 'mysql', label: 'MySQL' },
        { value: 'sqlserver', label: 'SQL Server' },
        { value: 'mongodb', label: 'MongoDB' }
      ],
      scenesSelected: ['test'],
      developDeploymentInfo: {
        scenes: 'develop',
        jenkins_id: '',
        jenkins_job: '',
        server: [],
        address_in: '',
        address_ex: ''
      },
      testDeploymentInfo: {
        scenes: 'test',
        jenkins_id: '',
        jenkins_job: '',
        server: [],
        address_in: '',
        address_ex: ''
      },
      productDeploymentInfo: {
        scenes: 'product',
        jenkins_id: '',
        jenkins_job: '',
        server: [],
        address_in: '',
        address_ex: ''
      },
      submitting: false,
      moduleInfoError: false,
      deploymentInfoError: false
    }
  },
  watch: {
    '$route' () {
      this.getInitData()
    },
    '$store.state.user.defaultTenant' () {
      this.getSelTenant()
    }
  },
  created: function () {
    this.getInitData()
    this.getSelTenant()
  },
  methods: {
    // 初始化数据
    getInitData () {
      this.getAllUserData()
      this.getModuleDetailInfo()
      this.getModuleDevelopmentInfo()
    },
    // 获取模块详细信息
    getModuleDetailInfo () {
      if (this.$route.params.id) {
        detailModule(this.$route.params.id).then(res => {
          for (let i in this.baseInfo) {
            let idsM = ['developers']
            let data = res.data[i]
            if (idsM.indexOf(i) > -1) {
              let ids = []
              for (let v in data) {
                ids.push(data[v].id)
              }
              this.baseInfo[i] = ids
            } else {
              this.baseInfo[i] = res.data[i]
            }
          }
          this.moduleInfoError = false
        }).catch(res => {
          this.moduleInfoError = true
        })
      }
    },
    // 获取模块的所有部署环境信息
    getModuleDevelopmentInfo () {
      if (this.$route.params.id) {
        getModuleDevelopments(this.$route.params.id).then(res => {
          this.scenesSelected = []
          if (res.data.develop) {
            this.scenesSelected = ['develop']
            this.developDeploymentInfo = res.data.develop
          }
          if (res.data.test) {
            this.scenesSelected.push('test')
            this.testDeploymentInfo = res.data.test
          }
          if (res.data.product) {
            this.scenesSelected.push('product')
            this.productDeploymentInfo = res.data.product
          }
          this.deploymentInfoError = false
        }).catch(res => {
          this.deploymentInfoError = true
        })
      }
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    // 获取所选的租户信息
    getSelTenant () {
      if (this.$store.state.user.defaultTenant) {
        detailTenants(this.$store.state.user.defaultTenant).then(res => {
          this.tenantInfo = res.data
        })
      }
    },
    // 打开选择服务器对话框
    openSelectServerModal (se, ref) {
      let selected = {}
      for (let i in this[se].server) {
        selected[this[se].server[i].hostname] = this[se].server[i].id
      }
      this.$refs[ref].openSelectServerModal({}, selected)
    },
    // 选择服务器完成回调
    developSelectServerComplete (server) {
      this.developDeploymentInfo.server = this.serverObjectTransArray(server)
    },
    // 选择服务器完成回调
    testSelectServerComplete (server) {
      this.testDeploymentInfo.server = this.serverObjectTransArray(server)
    },
    // 选择服务器完成回调
    productSelectServerComplete (server) {
      this.productDeploymentInfo.server = this.serverObjectTransArray(server)
    },
    // 服务器对象转换数组
    serverObjectTransArray (server) {
      let ss = []
      for (let i in server) {
        ss.push({hostname: i, id: server[i]})
      }
      return ss
    },
    // 数组校验器
    validArrayRule (rule, value, callback) {
      if (value === 0) {
        callback(new Error())
      } else {
        callback()
      }
    },
    // 打开选中Jenkins对话框
    openSelectJenkins (callbackParams) {
      this.$refs.SelectJenkinsJobs.openModal(this[callbackParams].jenkins_job, this[callbackParams].jenkins_id, callbackParams)
    },
    // 选择jenkins完成
    selectJenkinsJobsComplete (jenkinsId, job, callbackParams) {
      this[callbackParams].jenkins_id = jenkinsId
      this[callbackParams].jenkins_job = job
    },
    // 提交数据
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          let reqData = {
            module: this.baseInfo
          }
          if (this.scenesSelected.indexOf('develop') > -1) {
            if (!this.developDeploymentInfo.jenkins_id || !this.developDeploymentInfo.jenkins_job) {
              this.$Notice.error({title: 'Jenkins不能为空'})
              return
            }
            reqData['developDeploymentInfo'] = this.developDeploymentInfo
          }
          if (this.scenesSelected.indexOf('test') > -1) {
            if (!this.testDeploymentInfo.jenkins_id || !this.testDeploymentInfo.jenkins_job) {
              this.$Notice.error({title: 'Jenkins不能为空'})
              return
            }
            reqData['testDeploymentInfo'] = this.testDeploymentInfo
          }
          if (this.scenesSelected.indexOf('product') > -1) {
            if (!this.productDeploymentInfo.jenkins_id || !this.productDeploymentInfo.jenkins_job) {
              this.$Notice.error({title: 'Jenkins不能为空'})
              return
            }
            reqData['productDeploymentInfo'] = this.productDeploymentInfo
          }
          this.submitting = true
          changeModule(reqData, this.baseInfo.id).then(res => {
            this.$Notice.success({title: '操作成功'})
            this.$router.push({name: 'module_detail', params: { id: res.data.id }})
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .workflow-module-edit-content {
    .draw-process-btn-inactive {
      color: #999 !important;
      border-color: #999 !important;
    }
    .ivu-steps {
      margin-top: 10px;
    }
    .develop-deployment-info-form {
      .ivu-steps {
        .ivu-steps-head {
          background: #F0FAFF;
        }
        .ivu-steps-title {
          background: #F0FAFF;
        }
      }
    }
    .test-deployment-info-form {
      .ivu-steps {
        .ivu-steps-head {
          background: #FFF9E6;
        }
        .ivu-steps-title {
          background: #FFF9E6;
        }
      }
    }
    .product-deployment-info-form {
      .ivu-steps {
        .ivu-steps-head {
          background: #FFEFE6;
        }
        .ivu-steps-title {
          background: #FFEFE6;
        }
      }
    }
    .ivu-alert.ivu-alert-with-icon {
      padding: 8px 8px 8px 30px;
    }
    .ivu-alert-icon{
      left: 8px;
    }
  }
</style>
